import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class FlightbridgeService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) {}

  async postFlightBridgeSSOInitial(): Promise<any> {
    const URL = `${environment.airportsApiUrl}/customer/flightbridgesso`;
    try {
      const BODY = {};
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

}
